import Button from "../../../library/button";
import { Text } from "../../../library/text";
import { Title } from "../../../library/title";
import { getIcon } from "../../../utils/get-icon";
import ToggleButtons from "../../../library/toggle-buttons";
import {
  Container,
  ListWrapper,
  PriceWrapper,
  ToggleWrapper,
  InnerWrapper,
  SubscriptionTiersWrapper,
  SubscriptionTierCard,
  TopContentWrapper,
  FeatureRow,
  FeatureTitle,
  FeatureIcon,
  ListGroup,
} from "./styled";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  SUBSCRIPTION_TIERS,
  TRANSCRIPTION_FEATURES,
  VIDEO_EDITING_FEATURES,
} from "./utils";
import { Link } from "react-router-dom";

const Content = () => {
  const { t } = useTranslation();
  const [selectedSubscription, setSelectedSubscription] =
    useState<string>("monthly");

  const handleTabSelection = (selection: string) => {
    setSelectedSubscription(selection);
  };

  const formatPriceWithThousandSeparator = (price: number | string): string => {
    const priceString = String(price);
    return priceString.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const renderPeriod = (period: string) => {
    return period === "monthly" ? "måned" : "år";
  };

  const renderPrice = (tier: any, price: any, period: any) => {
    if (tier.title === "Randi Enterprise") {
      return "Pris forhandles";
    } else {
      return `${formatPriceWithThousandSeparator(price)}kr pr ${renderPeriod(
        period
      )}`;
    }
  };

  return (
    <Container>
      <InnerWrapper>
        <ToggleWrapper>
          <ToggleButtons
            selected={selectedSubscription}
            options={[
              {
                title: t(
                  "register.views.select-subscription.payment-duration.monthly-selection.title"
                ),
                value: "monthly",
              },
              {
                title: t(
                  "register.views.select-subscription.payment-duration.annually-selection.title"
                ),
                value: "annually",
              },
            ]}
            onSelect={handleTabSelection}
          />
        </ToggleWrapper>
        <SubscriptionTiersWrapper>
          {SUBSCRIPTION_TIERS.map((tier) => {
            const priceIndex = selectedSubscription === "monthly" ? 0 : 1;
            return (
              <SubscriptionTierCard
                className={tier.title === "Randi Social" ? "highlight" : ""}
              >
                <TopContentWrapper>
                  <Title size="sm">{tier.title}</Title>
                  <Text size="small" color="dark">
                    {tier.description}
                  </Text>
                  <PriceWrapper>
                    <Title size="md">
                      {renderPrice(
                        tier,
                        tier.prices[priceIndex],
                        selectedSubscription
                      )}
                    </Title>
                  </PriceWrapper>

                  {tier.title === "Randi Enterprise" ? (
                    <Link to="mailto:andreas@randi.ai">
                      <Button color="blue" variant="regular">
                        Kontakt oss
                      </Button>
                    </Link>
                  ) : (
                    <Link to="/register">
                      <Button color="blue" variant="regular">
                        Kom i gang
                      </Button>
                    </Link>
                  )}
                </TopContentWrapper>
                <ListWrapper>
                  <ListGroup>
                    <Title size="xs">Transkribering</Title>
                    {TRANSCRIPTION_FEATURES.find(
                      (x) => x.plan === tier.title
                    )?.list.map((feature) => (
                      <FeatureRow>
                        <FeatureIcon className="check">
                          {getIcon("list-check")}
                        </FeatureIcon>

                        <FeatureTitle>{feature}</FeatureTitle>
                      </FeatureRow>
                    ))}
                  </ListGroup>
                  <ListGroup>
                    <Title size="xs">Videoredigering</Title>
                    {VIDEO_EDITING_FEATURES.find(
                      (x) => x.plan === tier.title
                    )?.list.map((feature) => (
                      <FeatureRow>
                        <FeatureIcon className="check">
                          {getIcon("list-check")}
                        </FeatureIcon>

                        <FeatureTitle>{feature}</FeatureTitle>
                      </FeatureRow>
                    ))}
                  </ListGroup>
                </ListWrapper>
              </SubscriptionTierCard>
            );
          })}
        </SubscriptionTiersWrapper>
      </InnerWrapper>
    </Container>
  );
};

export default Content;
